module.exports = function() {
	return new Worker(__webpack_public_path__ + "bfcc4160e607c77dfaba.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./src/worker.js
// module id = 609
// module chunks = 0